/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import * as types from "./types";

export const state = {
  wallet: {},
  withdraw: {
    transaction: null,
    payment: null,
    withdraw: null
  },
  kind: "",
  filtersOrdination: "",
  filtersTransactionType: "",
  withdrawError: false,
  withdrawErrorMessage: "",
  withdrawSuccess: false,
  notificationBar: false,
  all: [],
  received: [],
  receivedsTotal: 0,
  sended: [],
  sendedsTotal: 0,
  filtersId: "",
  filtersPositive: "",
  filtersTypeId: "",
  filtersKind: "",
  filtersAmount: "",
  filtersInitialDate: "",

  limitOptions: [10, 25, 50, 100],
  totalResources: 0,
  page: 1,
  limit: 10,
  loadingData: true,
  showFilters: false,
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_created_at_between: {
        start_at: null,
        end_at: null
      },
      sorted_by: null,
      kind: null,
      positive: null
    }
  }
};

export const mutations = {
  [types.SET_ALL](state, all) {
    state.all = all;
  },
  [types.SET_RECEIVEDS](state, received) {
    state.received = received;
  },
  [types.RECEIVEDS_TOTAL](state, param) {
    state.receivedsTotal = param;
  },
  [types.SET_SENDEDS](state, sended) {
    state.sended = sended;
  },
  [types.SENDEDS_TOTAL](state, param) {
    state.sendedsTotal = param;
  },
  [types.SET_WALLET_DATA](state, data) {
    state.wallet = data;
  },
  [types.PAGE](state, param) {
    state.page = param;
  },
  [types.LIMIT](state, param) {
    state.limit = param;
  },
  [types.TOTAL_RESOURCES](state, total) {
    state.totalResources = total;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.WITHDRAW](state, param) {
    state.withdraw = param;
  },
  [types.WITHDRAW_SUCCESS](state, param) {
    state.withdrawSuccess = param;
  },
  [types.WITHDRAW_ERROR](state, param) {
    state.withdrawError = param;
  },
  [types.WITHDRAW_ERROR_MESSAGE](state, param) {
    state.withdrawErrorMessage = param;
  },
  [types.NOTIFICATION_BAR](state, param) {
    state.notificationBar = param;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_FILTER_ID](state, id) {
    state.filtersId = id;
  },
  [types.KIND](state, param) {
    state.kind = param;
  },
  [types.SET_FILTER_POSITIVE](state, positive) {
    state.filtersPositive = positive;
  },
  [types.SET_FILTER_TYPE_ID](state, typeId) {
    state.filtersTypeId = typeId;
  },
  [types.SET_FILTER_KIND](state, kind) {
    state.filtersKind = kind;
  },
  [types.SET_FILTER_TYPE_AMOUNT](state, amount) {
    state.filtersAmount = amount;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.FILTER_INITIAL_DATE](state, date) {
    state.initialDate = date;
  },
  [types.FILTER_FINAL_DATE](state, date) {
    state.finalDate = date;
  }
};
